module.exports = __webpack_public_path__ + "img/image34@2x.9933c179.png";